function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import config from '../../tokens/modal.json';
import { overlayTemplate, ModalTemplate } from '../templates/_modal.tpl.js';
import { template } from '../commons/_template.js';

/**
 * How to create a modal instance
 *
 * If modal exist on DOM
 * this.modal = new Modal({
        "classContent": '.js-myModal', // string -> query selector
        "onOpen": function() {
            console.log('open');
        },
        "onClose": function() {
            console.log('close');
        }
    });

  * If modal doesn't exist on DOM
    this.generatingModal = new Modal({
        {
          "content": {
              "classContent": "",
              "title": { //required
                  "text": "string", required
                  "heading": "number", default 2
              },
              "subTitle": { // optional
                  "text": "My title",
                  "heading": "number", default 3
              },
              contentHTML: "",
              "footer": {
                "fstCta": { //required
                  "label": "",
                  "innerData": {
                    "data-toto": "",
                    "class": ""
                  }
                },
                "sndCta": {
                  "type": "link|button",
                  "href": "#", // if type == link
                  "label": "",
                  "innerData": {
                    "data-toto": "",
                    "class": ""
                  }
                },
              }
            }, // object -> modal generation
            "blocked": false, // Boolean default: false
            "scrollable": true, // optional, default true
          "onOpen": () => {},
          "onClose": () => {}
        }

    });
*/

var MODAL_CONSTANTS = {
  fstCtaSelector: 'js-modal-first-cta',
  sndCtaSelector: 'js-modal-second-cta',
  bodyClass: "".concat(config["class"]).concat(config.open),
  dialogClass: "".concat(config["class"]).concat(config.dialog),
  modalOpenedClass: 'is-open',
  overlayOpenedClass: 'is-visible',
  overlayBlockedClass: 'is-blocked'
};
function $initEvents() {
  var _this = this;
  this.modal.delegateEvent('click', '.js-modal-close', function (e) {
    e.stopPropagation();
    _this.close();
  });
}
var allModals = [];
var Modal = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {String} content : The modal's id attribute
   * @param {Object} options
   */
  function Modal(prmOptions) {
    var _this2 = this;
    _classCallCheck(this, Modal);
    // init options
    var defaultOptions = {
      'classContent': null,
      'id': "modal-".concat(allModals.length + 1),
      'onOpen': function onOpen() {
        return true;
      },
      'onClose': function onClose() {
        return true;
      }
    };
    this.options = Object.assign(defaultOptions, prmOptions);
    this.displayed = false;
    this.$oldFocusedElement = null;

    // get the modal or create it    //
    if (this.options.content !== undefined) {
      if (_typeof(this.options.content) === 'object') {
        this.modal = this.generateModalDOM();
      }
    } else {
      this.modal = document.querySelector(".".concat(this.options.classContent));
    }
    if (this.modal) {
      this.modalTitleLabel = document.getElementById(this.modal.getAttribute('aria-labelledby')).innerHTML;
      this.modalDialog = this.modal.querySelector(".".concat(MODAL_CONSTANTS.dialogClass));
      this.$fstCta = this.modal.querySelector(".".concat(MODAL_CONSTANTS.fstCtaSelector));
      this.$sndCta = this.modal.querySelector(".".concat(MODAL_CONSTANTS.sndCtaSelector));
      $initEvents.call(this);
    }

    // Add the overlay
    this.overlay = this.generateOverlayDOM();
    this.overlay.addEventListener('click', function (event) {
      if (_this2.modalDialog.matches(".".concat(MODAL_CONSTANTS.modalOpenedClass)) && _this2.overlay.matches(".".concat(MODAL_CONSTANTS.overlayOpenedClass)) && !_this2.modalDialog.matches(".".concat(MODAL_CONSTANTS.overlayBlockedClass))) {
        event.stopPropagation();
        _this2.close();
      }
    });

    // Keyboard management
    this.escapeModal();

    // Store all modals in this object
    allModals.push(this);
  }
  return _createClass(Modal, [{
    key: "open",
    value: function open() {
      // Only one modal at a time
      this.closeOtherModals();
      if (typeof this.options.onOpen === 'function') {
        this.options.onOpen(this);
      }
      document.body.classList.add(MODAL_CONSTANTS.bodyClass);
      this.displayed = true;

      // Give accessibility to the modal
      this.modal.setAttribute('tabindex', '0');
      this.modal.setAttribute('aria-hidden', 'false');

      // Get the first element of the modal to be able to loop
      this.firstFocusable = this.modal.querySelector('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])') || this.layer;
      this.trapFocus();

      // Open modal
      this.modalDialog.classList.add(MODAL_CONSTANTS.modalOpenedClass);
      this.overlay.classList.add(MODAL_CONSTANTS.overlayOpenedClass);

      // Get last focused element
      this.$oldFocusedElement = document.activeElement;

      // Focus first focusable element when modal is open
      this.firstFocusable.focus({
        preventScroll: true
      });

      // Fix scroll
      document.children[0].style.scrollBehavior = 'auto';
      document.children[0].classList.add('is-scroll-locked');
    }
  }, {
    key: "close",
    value: function close() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        'chainedModal': false
      };
      if (!options.chainedModal) {
        if (typeof this.options.onClose === 'function') {
          this.options.onClose(this);
        }
        document.body.classList.remove(MODAL_CONSTANTS.bodyClass);
        this.displayed = false;

        // Remove accessibility from the modal
        this.modal.setAttribute('tabindex', '-1');
        this.modal.setAttribute('aria-hidden', 'true');

        // Hide modal
        this.modalDialog.classList.remove(MODAL_CONSTANTS.modalOpenedClass);
        this.overlay.classList.remove(MODAL_CONSTANTS.overlayOpenedClass);

        // Remove fix scroll
        document.children[0].classList.remove('is-scroll-locked');

        // Restore focus
        if (this.$oldFocusedElement !== undefined && this.$oldFocusedElement !== null) this.$oldFocusedElement.focus();
      }

      // Remove accessibility from the modal
      this.modal.setAttribute('tabindex', '-1');
      this.modal.setAttribute('aria-hidden', 'true');
      this.displayed = false;
      this.modalDialog.classList.remove(MODAL_CONSTANTS.modalOpenedClass);
    }
  }, {
    key: "closeOtherModals",
    value: function closeOtherModals() {
      for (var i = 0; i < allModals.length; i++) {
        if (allModals[i].displayed) {
          allModals[i].close({
            'chainedModal': true
          });
        }
      }
    }
  }, {
    key: "trapFocus",
    value: function trapFocus() {
      var focusableElements = this.modal.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
      var firstFocusableElement = focusableElements[0];
      var lastFocusableElement = focusableElements[focusableElements.length - 1];
      document.addEventListener('keydown', function (e) {
        var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
        if (!isTabPressed) {
          return;
        }
        if (e.shiftKey) {
          // if shift key pressed for shift + tab combination
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        } else {
          // if tab key is pressed
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            e.preventDefault();
          }
        }
      });
    }
  }, {
    key: "escapeModal",
    value: function escapeModal() {
      var _this3 = this;
      document.addEventListener('keydown', function (event) {
        if ((event.keyCode === '27' || event.code === 'Escape') && !_this3.modalDialog.matches(".".concat(MODAL_CONSTANTS.overlayBlockedClass)) && _this3.displayed) {
          _this3.close();
        }
      });
    }
  }, {
    key: "generateModalDOM",
    value: function generateModalDOM() {
      document.body.insertAdjacentHTML('beforeend', template(ModalTemplate, this.options));
      return document.querySelector("div#js-".concat(this.options.id));
    }
  }, {
    key: "generateOverlayDOM",
    value: function generateOverlayDOM() {
      if (!document.getElementById('js-modal-overlay')) {
        document.body.insertAdjacentHTML('beforeend', template(overlayTemplate));
      }
      return document.getElementById('js-modal-overlay');
    }
  }]);
}();
export { Modal as default };